import { useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import LogoutIcon from "@mui/icons-material/Logout";

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className={styles.headerContainer}>
      <div className={styles.headerInnerContainer}>
        <h1 className={styles.siteTitle}>Psychology Pathways</h1>
        <div className={styles.iconContainer}>
          <div className={styles.logos}>
            <img
              src="/images/CSUFlogo.jpg"
              alt="CSUF Logo"
              className={styles.csufLogo}
            />
            <img
              src="/images/NSFlogo.png"
              alt="NSF Logo"
              className={styles.nsfLogo}
            />
          </div>

          <span className={styles.headerDivider} aria-hidden="true" />

          <button
            type="button"
            className={styles.logoutButton}
            onClick={() => {
              navigate("/logout");
            }}
          >
            <LogoutIcon aria-hidden="true" />
            <span>Log out</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
